import InstructorService from "@/services/instructor.service";
import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { InstructorState } from "./types";

const service = new InstructorService();

export const actions: ActionTree<InstructorState, RootState> = {
  getInstructorDetail(_, callback: ActionCallback) {
    service
      .getInstructorDetail(callback?.params)
      .then((response) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  getInstructors(_, callback: ActionCallback) {
    service
      .getInstructors(callback?.params)
      .then((response) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
};
